import config from '../../config';
import { TestPlanStepStatus } from '../../types/TestPlanStepStatus';
import { prepareTester } from '../../util/dataTransformer';

function listCycles4CustomerSlim(): any {
  return async (dispatch) => {
    dispatch({
      type: 'LIST_CYCLES_SLIM_START',
    });

    try {
      const response = await fetch(`${config.apiEndpoint}/api/cyclesslim`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (response.status !== 200) {
        if (response.status === 401 || response.status === 403) {
          return dispatch({
            type: 'UNAUTHORIZED_REQUEST',
          });
        }

        const errorMessage = await response.json();

        return dispatch({
          type: 'LIST_CYCLES_SLIM_FAIL',
          errorMessage,
        });
      }

      const cyclesSlim = await response.json();            
      dispatch({
        type: 'LIST_CYCLES_SLIM_SUCCESS',
        cyclesSlim,
      });
    } catch (e) {
      dispatch({
        type: 'LIST_CYCLES_SLIM_FAIL',
        errorMessage: 'Unable to connect. Please try again later',
      });
    }
  };
}


//Shouldn't be used for Customers anymore, we use the Slim version
//We keep it for Testers only
function listCycles(): any {
  return async (dispatch) => {
    dispatch({
      type: 'LIST_CYCLES_START',      
    });    

    try {
      const response = await fetch(`${config.apiEndpoint}/api/cycles`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (response.status !== 200) {
        if (response.status === 401 || response.status === 403) {
          return dispatch({
            type: 'UNAUTHORIZED_REQUEST',
          });
        }

        const errorMessage = await response.json();

        return dispatch({
          type: 'LIST_CYCLES_FAIL',
          errorMessage,
        });
      }

      const cycles = await response.json();

      for (let cycle of cycles) {
        if (cycle.testers) {
          for (let tester of cycle.testers) {
            tester = prepareTester(tester);
          }
        }

        if (cycle.bugs) {
          for (let bug of cycle.bugs) {
            bug.device = JSON.parse(bug.device);
          }
        }

        // TODO remove later
        cycle.bugsFound = cycle.bugs ? cycle.bugs.length : 0;

        if (cycle.approvedDevice) {
          cycle.approvedDevice = JSON.parse(cycle.approvedDevice);
        }
      }

      dispatch({
        type: 'LIST_CYCLES_SUCCESS',
        cycles,
      });
    } catch (e) {
      dispatch({
        type: 'LIST_CYCLES_FAIL',
        errorMessage: 'Unable to connect. Please try again later',
      });
    }
  };
}

function updateTestPlanStep(cycleId: number, testPlanStepId: number, status: TestPlanStepStatus) {
  return async (dispatch) => {
    dispatch({ type: 'TEST_PLAN_STEP_UPDATE_START' });

    try {
      const response = await fetch(
        `${config.apiEndpoint}/api/cycles/${cycleId}/test-plan/steps/${testPlanStepId}`,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ status }),
        }
      );

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          return dispatch({
            type: 'UNAUTHORIZED_REQUEST',
          });
        }

        return dispatch({
          type: 'TEST_PLAN_STEP_UPDATE_FAIL',
          errorMessage: (await response.json()).message,
        });
      }

      return dispatch({
        type: 'TEST_PLAN_STEP_UPDATE_SUCCESS',
        cycleId,
        testPlanStepId,
        status,
      });
    } catch (e) {
      console.error(e);
      return dispatch({ type: 'TEST_PLAN_STEP_UPDATE_FAIL' });
    }
  };
}

function getCycleFull(id) {
  return async (dispatch) => {
    dispatch({ type: 'GET_CYCLE_FULL_START' });

    const response = await fetch(`${config.apiEndpoint}/api/cyclesFull/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    const cycle = await response.json();

    if (cycle.testers) {
      for (let tester of cycle.testers) {
        tester = prepareTester(tester);
      }
    }

    if (cycle.bugs) {
      for (let bug of cycle.bugs) {
        bug.device = JSON.parse(bug.device);
      }
    }

    // TODO remove later
    cycle.bugsFound = cycle.bugs ? cycle.bugs.length : 0;

    if (cycle.approvedDevice) {
      cycle.approvedDevice = JSON.parse(cycle.approvedDevice);
    }
    
    return dispatch({
      type: 'GET_CYCLE_FULL_SUCCESS',
      cycle,
    });
  };
}


export default {
  listCycles,
  listCycles4CustomerSlim,
  updateTestPlanStep,
  getCycleFull,  
};
